@if (customText != undefined) {
  <app-custom-text [customTextParam]="customText"></app-custom-text>
}
